'use client';

import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useBookingModals } from '@/features/Booking';
import { Schedule } from './Schedule';
import type { IScheduleInMedcenter } from '@/entities/medcenter/model/types';
import type { DoctorScheduleProps } from '../model/types';
export const DoctorSchedule: React.FC<DoctorScheduleProps> = ({
  bookingData,
  medcenterId,
  medcenters,
  doctorId,
  scheduleClick
}) => {
  const [showSchedule, setShowSchedule] = useState(false);
  const [schedule, setSchedule] = useState<IScheduleInMedcenter[]>([]);
  const {
    setVisibleBookingModal
  } = useBookingModals();
  const hasOnlineBookingInMedcenter = useMemo(() => {
    if (medcenterId) {
      const medcenter = medcenters.find(item => item.id === medcenterId);
      return medcenter?.hasOnlineBooking;
    }
    return false;
  }, [medcenterId, medcenters]);
  const emptyTimeslots = useMemo(() => {
    if (medcenterId) {
      const medcenter = medcenters.find(item => item.id === medcenterId);
      if (medcenter?.hasOnlineBooking) {
        const booking = bookingData.find(item => item.medcenterId === medcenterId);
        if (booking) {
          return booking.onlineBooking.timeslotsIsEmpty && booking.onlineBooking.basedOn !== 'preferred_time';
        }
      }
    }
    return false;
  }, [medcenterId, medcenters, bookingData]);

  // @todo: отрефакторить дубли
  const hasOnline = useMemo(() => {
    if (medcenterId) {
      const booking = bookingData.find(item => item.medcenterId === medcenterId);
      const medcenter = medcenters.find(item => item.id === medcenterId);
      if (medcenter && !medcenter.hasOnlineBooking) {
        return false;
      }
      if (booking) {
        const {
          timeslotsIsEmpty,
          basedOn,
          schedule
        } = booking.onlineBooking;
        if ((timeslotsIsEmpty || schedule?.length === 0) && basedOn !== 'preferred_time') return false;
        return true;
      }
    }
    return false;
  }, [medcenterId, medcenters, bookingData]);
  const handleScheduleClick = useCallback(() => {
    setVisibleBookingModal(true, doctorId);
    if (typeof scheduleClick === 'function') {
      scheduleClick(doctorId, bookingData);
    }
  }, [hasOnline, setVisibleBookingModal, doctorId, scheduleClick, bookingData]);
  useEffect(() => {
    if (medcenterId) {
      const medcenter = medcenters.find(item => item.id === medcenterId);
      setSchedule(medcenter?.schedule || []);
    }
  }, [medcenterId, medcenters]);
  useEffect(() => {
    if (medcenterId) {
      const booking = bookingData.find(item => item.medcenterId === medcenterId);
      if (bookingData.length === 0 && !hasOnlineBookingInMedcenter) {
        setShowSchedule(true);
      }
      if (booking) {
        setShowSchedule((booking.onlineBooking.basedOn === 'preferred_time' || booking.onlineBooking.timeslotsIsEmpty) && !!schedule.length);
      }
    }
  }, [schedule, bookingData, medcenterId]);
  if (!showSchedule) {
    return null;
  }
  return <Schedule schedule={schedule} hasOnlineBookingInMedcenter={hasOnlineBookingInMedcenter} emptyTimeslots={emptyTimeslots} onScheduleClick={hasOnline ? handleScheduleClick : undefined} data-sentry-element="Schedule" data-sentry-component="DoctorSchedule" data-sentry-source-file="DoctorSchedule.tsx" />;
};